type Props = {
    action?: React.ReactNode;
    children: React.ReactNode;
};

export const SectionHeading: React.FC<Props> = ({ action, children }) => (
    <div className="mx-3 mb-2 flex min-h-10 items-center justify-between gap-2 rounded bg-white px-2 py-2 text-sm font-bold text-midnight">
        <span>{children}</span>
        {action}
    </div>
);
